import { Component, input, InputSignal } from '@angular/core';

/** One "for eg." city row in the location sheet. The sentence is already translated by the caller. */
@Component({
  selector: 'app-location-example-card',
  templateUrl: './location-example-card.component.html',
})
export class LocationExampleCardComponent {
  iconSrc: InputSignal<string> = input.required<string>();
  text: InputSignal<string> = input.required<string>();
}
